import React from 'react'
import { Grid, Container, Box } from '@material-ui/core'
import FormListCont from '../containers/FormListCont'
import CreateNewCont from '../containers/CreateNewCont'
import AddFormButton from '../containers/AddFormButton'
import EmazeForm from '../containers/EmazeForm'
import './FormActions.scss'

function FormActions({main}){       
    return (
        <Container className="form-actions-container">
            <Grid container justifyContent="center">
                <Grid item xs={6}>
                    <Box m="20px 0 0" className="list-container">
                        <Grid container justifyContent="center">
                            <Grid item xs={10}>
                                <Box className="title" m="20px 0 0 0">Manage your forms</Box>
                            </Grid>
                            <Grid item xs={10}>
                                <CreateNewCont></CreateNewCont>
                            </Grid>
                            <Grid item xs={10}>
                                <FormListCont></FormListCont>
                            </Grid>
                        </Grid>
                    </Box>                    
                </Grid>
                <Grid item xs={6}>
                    <Box m="45px 0 0" className="preview-container">
                        <Box m="5px 0 5px 20px">
                            <Box className="title">Preview</Box>
                        </Box>
                        <Box m="10px 0 10px 20px" className="description">
                            Make it easy for people to reach you 24/7.
                        </Box>            
                        <Box m="5px 0 5px 20px" className="emaze-form">
                            {
                                main.selectedForm !=null ?
                                <EmazeForm isPreview={true}></EmazeForm> 
                                :
                                <></>
                            }                            
                        </Box>
                    </Box>
                </Grid> 
                <Grid item xs={8}>
                    <Box display="flex" justifyContent="flex-end" alignItems="center" m="30px 0 0">
                        <AddFormButton></AddFormButton>
                    </Box>
                </Grid>
            </Grid>
        </Container>        
    )
}

export default FormActions;